Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var container = {
    maxWidth: 700,
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'center',
    flexDirection: bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m, bp.mobile_l]) ? 'column' : 'row'
  };
  var arrow = {
    width: 29,
    height: 41,
    margin: spacing.m,
    transform: bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m, bp.mobile_l]) ? [{
      rotate: '90deg'
    }] : []
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    arrow: arrow
  });
  return {
    styles: styles
  };
};